import type { FrontendBackendRow } from '../../masterdependency/framework';

type Props = { items?: FrontendBackendRow[] };

export function FrontendBackendWorkflowPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.domain}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-400">{item.domain}</p>
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.item}</p>
            <span className="shrink-0 rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {item.status}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">Depends on: {item.dependsOn}</p>
        </div>
      ))}
    </div>
  );
}
